<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink"
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 15 14">
    <path d="M15 9q0 1.242-0.879 2.121t-2.121 0.879h-8.5q-1.445 0-2.473-1.027t-1.027-2.473q0-1.031 0.555-1.887t1.461-1.277q-0.016-0.219-0.016-0.336 0-1.656 1.172-2.828t2.828-1.172q1.234 0 2.238 0.688t1.465 1.797q0.547-0.484 1.297-0.484 0.828 0 1.414 0.586t0.586 1.414q0 0.586-0.32 1.078 1.008 0.234 1.664 1.051t0.656 1.871z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-cloud.html